import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BrushCustom(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { fill: "currentColor", d: "M6.461 20.32a4.1 4.1 0 0 1-1.697-.376 4.1 4.1 0 0 1-1.399-1.008q.573-.163 1.085-.695.51-.532.511-1.42 0-1.048.726-1.774a2.41 2.41 0 0 1 1.774-.726q1.049 0 1.774.726t.726 1.774q0 1.443-1.028 2.472T6.461 20.32m0-1.5q.825 0 1.413-.587.587-.587.587-1.412a.97.97 0 0 0-.287-.713.97.97 0 0 0-.713-.287.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .575-.137 1.05a4.7 4.7 0 0 1-.363.9q.126.05.25.05zm5.308-4.057-2.23-2.23 8.565-8.566a.98.98 0 0 1 .687-.287.93.93 0 0 1 .712.287l.831.83q.3.3.3.7t-.3.7z" })));
}
const BrushCustom = forwardRef(_BrushCustom);
export { BrushCustom };
